export const enum ImageGalleryItemTypeEnum {
  IMAGE = 0,
  IFRAME = 1,
  YOUTUBE = 2,
  FLOOR_PLAN = 3,
  NUDGE = 4,
  COMMUNITY = 5,
  TOWER = 6,
}
